import { defineStore } from "pinia";

export const useUiStore = defineStore("ui", {
  state: () => ({
    snackbar: {
      showing: false,
      text: "",
      color: "success",
      timeout: 10000,
      actionText: null,
      action: null,
    },
  }),
  actions: {
    setSnackbar(snackbar = {}) {
      this.snackbar = {
        showing: true,
        text: snackbar.text || "",
        color: snackbar.color || "success",
        timeout: snackbar.timeout != null ? snackbar.timeout : 10000,
        actionText: snackbar.actionText || null,
        action: snackbar.action || null,
      };
    },
    hideSnackbar() {
      this.snackbar.showing = false;
    },
  },
});

export function setSnackbar(payload) {
  return useUiStore().setSnackbar(payload);
}
